import { IServiceWallet } from '@api/FW/serviceWallets/types';
import { WalletType } from '@app/shared/constants/enums';
import { IWalletItem } from '@interfaces/FW/Wallets';

export const filterTransitWalletType = (data: IWalletItem[]) => {
	return data.filter((item) => item.walletType !== WalletType.transit);
};

export const getOrdinaryWallets = (data: IWalletItem[]) => {
	return data.filter((item) => item.walletType === WalletType.ordinary);
};

export const getIndividualWallets = (data: IWalletItem[]) => {
	return data.filter((item) => item.walletType === WalletType.individual);
};

export const getTransitWallets = (data: IServiceWallet[]) => {
	return data.filter((item) => item.walletType === WalletType.transit);
};

export const getBlockedResourcesWallets = (data: IServiceWallet[]) => {
	return data.filter((item) => item.walletType === WalletType.blockedResources);
};
